import { FuseNavigationItem } from '@fuse/components/navigation';
import type { Navigation } from 'app/core/navigation/navigation.types';

export const ADMIN_ERROR_404_PATH = '/admin/error/404';
export const DEFAULT_ADMIN_PATH_PRIORITY = ['/dashboard'];

export function normalizeAdminPath(path: string | null | undefined): string {
  const cleanPath = (path ?? '').trim();

  if (!cleanPath) {
    return '';
  }

  const withoutQuery = cleanPath.split('?')[0].split('#')[0];
  const normalized = withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`;

  return normalized.replace(/\/+$/, '') || '/';
}

export function flattenNavigationLinks(navigation: Navigation | null | undefined): string[] {
  const links = new Set<string>();

  collectNavigationLinks(navigation?.default ?? [], links);

  return Array.from(links);
}

export function getDefaultAdminPath(navigation: Navigation | null | undefined): string {
  const links = flattenNavigationLinks(navigation);

  const priorityPath = DEFAULT_ADMIN_PATH_PRIORITY.find((path) =>
    links.includes(normalizeAdminPath(path))
  );

  if (priorityPath) {
    return priorityPath;
  }

  return links[0] ?? ADMIN_ERROR_404_PATH;
}

export function hasAdminPermission(url: string, navigation: Navigation | null | undefined): boolean {
  const targetPath = normalizeAdminPath(url);

  if (!targetPath || targetPath === ADMIN_ERROR_404_PATH) {
    return true;
  }

  return flattenNavigationLinks(navigation).some((link) => {
    const permissionPath = normalizeAdminPath(link);

    return targetPath === permissionPath || targetPath.startsWith(`${permissionPath}/`);
  });
}

function collectNavigationLinks(items: FuseNavigationItem[], links: Set<string>): void {
  items.forEach((item) => {
    const link = normalizeAdminPath(item.link as string | undefined);

    if (link) {
      links.add(link);
    }

    if (item.children?.length) {
      collectNavigationLinks(item.children, links);
    }
  });
}
